/*
  Peptide Sanctuary cart drawer add-on button.
  Adds the add-on item, then fires the theme's own 'cart:update' event with fresh
  section HTML so the drawer refreshes in place (same path the theme uses).
  Checkout is untouched: the theme's #checkout button goes to Shopify checkout.
*/
(function () {
  if (window.__psCartUpsell) return;
  window.__psCartUpsell = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('.pss-upsell__add') : null;
    if (!button || button.disabled) return;
    event.preventDefault();

    var variantId = Number(button.getAttribute('data-variant-id'));
    var count = Number(button.getAttribute('data-cart-count')) || 0;
    var sectionIds = Array.prototype.map.call(
      document.querySelectorAll('cart-items-component[data-section-id]'),
      function (el) { return el.getAttribute('data-section-id'); }
    );
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    button.disabled = true;
    button.classList.add('is-loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data && data.status && Number(data.status) >= 400) {
          throw new Error(data.description || 'Could not add item');
        }
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: 'ps-cart-upsell',
            data: {
              source: 'ps-cart-upsell',
              itemCount: count + 1,
              variantId: String(variantId),
              sections: data.sections
            }
          }
        }));
      })
      .catch(function (error) {
        console.error(error);
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  });
})();
